
import $ from 'jquery';

import {initArticleVariantHandler} from './../detail/ArticleVariant.js';
import {showWishlistButton} from './../detail/WishlistButton.js';
import {getViewControllerName} from './Util.js';

// Convert jQuery load to Promise.
const loadPopupContent = ( url, popupEl ) => {
	return new Promise( resolve => {
		$( popupEl ).find( '.mdl_popup__body' ).load( url, () => resolve() );
	} );
}

const loadArticleDetailPopup = ( url, popupEl ) => {
	return new Promise( resolve => {

		// Rename details container to prevent duplicate IDs.
		const detailsContainerEl = document.getElementById( 'details_container' );
		if ( detailsContainerEl ) {
			detailsContainerEl.setAttribute( 'id', 'formerdetails_container' );
		}

		return loadPopupContent( url, popupEl ).then( () => {

			// update button
			// data.$element.addClass('active');
			//EN_KO.functions.initScalable($('.scalable'));

			// Update Article Variant HTML.
			initArticleVariantHandler( popupEl.querySelector( '#details_container' ) );

			// Show Wishlist Button if needed.
			showWishlistButton();

			resolve();
		} );
	} );
};

const closeArticlePopup = () => {

	// Clean Popup Content.
	$( '#popup_article_container' ).html( '' );

	// Restore details container.
	$( "#formerdetails_container" ).attr( 'id', 'details_container' );
};

const loadStockQuickview = ( anid_cnid, popupEl ) => {

	return new Promise( resolve => {

		let url;
		let qcolor = "";
		const aSelectionInputs = $( "input[name^=varselid]", $( "form.js-oxProductForm" ) );
		if ( aSelectionInputs.length > 0 ) {

			const aOptions = {};
			aSelectionInputs.each( function() {
				aOptions[$( this ).attr( "name" )] = $( this ).val();
			} );
			qcolor = aOptions["varselid[0]"];
		}
		//url = anid_cnid + "?quickview=2&quick_stock_color=" + qcolor;
		if ( document.location.href.indexOf( 'html' ) === -1 ) {

			url = '?cl=details&anid=' + $( '#articletobasketform [name="anid"]' ).val() + '&quickview=2&quick_stock_color=' + qcolor;
		} else {
			url = "?quickview=2&varselid[]=" + qcolor + '&anid=' + anid_cnid;
		}

		return loadPopupContent( url, popupEl ).then( () => {
			const EN_KO = window.EN_KO;
			EN_KO.functions.initConversionTracking();
			resolve();
		} );
	} );
};

async function renderPopupContent( anid_cnid, popupEl ) {

	if ( ! popupEl ) {
		return false;
	}

	// Handle Stock Quickview.
	if ( popupEl.matches( '#popup_click_and_reserve' ) ) {

		// Load Stock Quickview.
		return await loadStockQuickview( anid_cnid, popupEl ).then( () => {
			// Dispatch Custom Event.
			$( popupEl ).trigger( 'load_productmain_quick_stock.acl' );
			popupEl.dispatchEvent( new CustomEvent( 'popup_quick_stock_loaded.acl', { bubbles: true } ) );
		} );
	} else if ( popupEl.matches( '#popup_article' ) ) {

		// Normalize URL Element.
		const url = new URL( anid_cnid, document.location );

		// Create URL Object.
		url.searchParams.set( 'quickview', '1' );
		url.searchParams.set( 'myurl', anid_cnid );

		// Load Stock Quickview.
		return await loadArticleDetailPopup( url.pathname + url.search + url.hash, popupEl ).then( () => {

			// Dispatch Custom Event.
			$( popupEl ).trigger( 'load_article_detail_popup.acl' );
			popupEl.dispatchEvent( new CustomEvent( 'popup_article_detail_loaded.acl', { bubbles: true } ) );
		} );
	} else {

		// Load any other Popup.
		return await loadPopupContent( anid_cnid, popupEl );
	}
}


$( document ).ready( function() {

	// Render Quickview.
	document.addEventListener( 'click', ( ev ) => {
		const linkEl = ev.target.closest( '.acl_js_load_popup' );
		if ( linkEl ) {
			ev.preventDefault();

			const target = linkEl.getAttribute( 'data-en-popup-target' );
			const href = linkEl.getAttribute( 'href' ) || linkEl.getAttribute( 'data-en-popup-href' ) || linkEl.getAttribute( 'data-popup-href' );

			if ( href && target ) {
				const popupEl = document.querySelector( target );
				if ( popupEl ) {

					// Add Loading Indicator.
					popupEl.classList.add( 'en_is_loading' );

					// Render Quickview Content -> Then open the popup.
					renderPopupContent( href, popupEl ).then( () => {

						// Open Popup.
						//EN_KO.functions.open_popup( popupEl );
					} ).finally( () => {

						// Remove Loading Indicator.
						popupEl.classList.remove( 'en_is_loading' );
					} );
				}
			}
		}
	} );

	// Close Article Quickview.
	document.addEventListener( 'popup_closed.sl', ( ev ) => {
		const popupEl = ev.target;
		if ( popupEl.matches( '#popup_article' ) ) {
			const v_cl = getViewControllerName();

			if ( v_cl === 'basket' && window.isArticleAdded ) {
				window.location.reload();
				window.isArticleAdded = false;
			} else {
				closeArticlePopup();
			}
		}
	} );
} );
